import React from 'react'
import { FormGroup, HelpText, InvalidFeedback, Label, Password } from './'

export const FormGroupPassword = props => {
    const { context, element, modelPath } = props;
    const inputModel = context.readModel(modelPath, element.defaultValue || "");

    return (
        <FormGroup required={element.required}>
            <Label text={element.text}></Label>
            <Password {...props}></Password>
            <HelpText text={element.helpText}></HelpText>    
            <InvalidFeedback element={element} errors={inputModel.errors}></InvalidFeedback>        
        </FormGroup>
    )
}

export default FormGroupPassword;